import * as React from "react";
import { Button, Divider, AppBar as MuiAppbar, Box, Typography, IconButton, Grid, MenuItem, Menu, Container } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
// import { useSlideInContext } from "../../../context/SlideInContext";
// import { CHANGE_PASSWORD } from "../SlideIn/contentTypes";
import usePersonStore from "../../store/personStore";
import usePersonAuthStore from "../../store/personAuthStore";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import axios from "axios";
import { useSlideInContext, } from "ui";
import { CHANGE_PASSWORD, ChangePasswordPayload } from "ft-shared-components"
const DEVELOPER = "DEVELOPER"

function AppMenu({ menuItems, roles, ...rest }: any) {
  const defaultLocation = usePersonStore(
    (state) => state.company.defaultLocation
  );


  const [menuAnchorElement, setMenuAnchorElement] =
    useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorElement(null);
  };

  const handleLocationChangeClick = () => {
    // handleContent(SELECT_LOCATION);
    handleCloseMenu();
  };

  // Separate signout menu item because we want ensure it's always placed at the bottom of the menu
  // and make injection of location menu item component "simpler"
  const signoutMenuItem = menuItems.find(
    (x: any) => x.id === "bac2d789-c2f0-40ae-90c5-e52f33ad0323"
  );

  const menuItemsFiltered = menuItems
    .filter(
      (x: any) =>
        (roles.includes("DEVELOPER") ||
          roles.includes("ADMIN")) ||
        roles.includes("OFFICE ADMIN") ||
        roles.includes("SUPER ADMIN") ||
        roles.includes("STANDARD") && x.requiredRole !== "ADMIN"
    )
    .filter((x: any) => x.id !== "bac2d789-c2f0-40ae-90c5-e52f33ad0323"); // remove signout from main list

  return (
    /* @ts-ignore */
    <Box component="div" {...rest}>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleOpenMenu}
      >
        <MenuIcon sx={{ fontSize: "36px" }} />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={menuAnchorElement}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(menuAnchorElement)}
        onClose={handleCloseMenu}
        PaperProps={{
          elevation: 10,
          sx: {
            overflow: "visible",
            width: 250,
          },
        }}
      >
        {menuItemsFiltered.map((item: any) => [
          <MenuItem
            key={item.id}
            onClick={() => {
              item.onClick();
              handleCloseMenu();
            }}
          >
            {item.label}
          </MenuItem>
        ])}

        <Divider />
        <MenuItem onClick={() => {
          handleCloseMenu();
        }}>
          User Guides</MenuItem>
        <Divider />
        <MenuItem onClick={signoutMenuItem.onClick}>
          {signoutMenuItem.label}
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default function AppBar() {
  const navigate = useNavigate();
  const { handleContent, toggleDrawer } = useSlideInContext();

  const destroyPersonStore = usePersonStore((state) => state.destroy);
  const username = usePersonStore(state => state.name);
  const roles = usePersonAuthStore((state) => state.roles);
  const destroyPersonAuthToken = usePersonAuthStore((state) => state.destroy);
  const accessToken = usePersonAuthStore(state => state.access_token)
  const personId = usePersonStore(state => state.id)

  const handleSignout = () => {
    destroyPersonAuthToken();
    destroyPersonStore();
    navigate("/login");
  };
  const handleSubmit = async (data: ChangePasswordPayload) => {
    var payload = JSON.stringify({
      "id": personId,
      "newPassword": data.newPassword,
      "oldPassword": data.oldPassword,
      "confirmPassword": data.confirmNewPassword,
    })
    var config = {
      method: 'post',
      url: `${window.__env.API_URL}/api/oauth/change-password`,
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    console.log("the payload: ", payload)
    //@ts-ignore
    await axios(config)
  }
  const navigation = [
    {
      id: "8020e04f-4e73-4d6d-a6bc-d0483e574e9f",
      label: "Home",
      requiredRole: DEVELOPER,
      onClick: () => {
        navigate("/dashboard");
      },
    },
    {
      id: "1e4b3436-bf08-4a5d-930a-743865dac5ec",
      label: "Change Password",
      requiredRole: DEVELOPER,
      onClick: () => {
        handleContent(CHANGE_PASSWORD, { onSubmit: handleSubmit });
        toggleDrawer();
      },
    },
    // {
    //   id: "6bd2db90-4ee4-4bfb-8784-4f99f87a1141",
    //   label: "Manage Companies",
    //   requiredRole: DEVELOPER,
    //   onClick: () => {
    //     navigate("/manage/children");
    //   },
    // },
    {
      id: "3212a84f-1c4c-46d1-bfbe-80dea416135d",
      label: "Manage Users",
      requiredRole: DEVELOPER,
      onClick: () => {
        navigate("/manage/users");
      },
    },
    {
      id: "3212a84f-1c4c-46d1-bfbe-80dea416135d",
      label: "Global Statistics",
      requiredRole: DEVELOPER,
      onClick: () => {
        navigate("/global-statistics");
      },
    },
    {
      id: "bac2d789-c2f0-40ae-90c5-e52f33ad0323",
      label: "Sign Out",
      requiredRole: DEVELOPER,
      onClick: () => {
        handleSignout();
      },
    },
  ];
  return (
    <MuiAppbar color="secondary" position="static">
      <Container maxWidth="xl">
        <Grid container>
          <Grid size={2}>
            <Link to="/dashboard">
              <Box
                component="div"
                sx={{
                  marginTop: 1.3,
                  marginBottom: 1.5,
                  height: "45px",
                  width: "45px",
                  backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/logos/ft_logo_sm.jpg)`,
                  backgroundSize: "cover",
                  borderRadius: "15px",
                }}
              />
            </Link>
          </Grid>
          <Grid
            size={10}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: "400" }}>
              {" "}
              {username ? `Welcome, ${username}` : ""}{" "}
            </Typography>
            <AppMenu
              sx={{ marginLeft: 1 }}
              menuItems={navigation}
              roles={roles}
            />
          </Grid>
        </Grid>
      </Container>
    </MuiAppbar>
  );
}
